export var IDENTIFIER_PAGER = 'pager';
export var IDENTIFIER_PAGER_ACTIONS_PREVIOUS = 'pager-previous';
export var IDENTIFIER_PAGER_ACTIONS_NEXT = 'pager-next';
export var IDENTIFIER_PAGER_PAGE = 'pager-page';
